import React, { ReactElement } from 'react';
import { ReactComponent as AlipayIcon } from 'payment-icons/min/flat/alipay.svg';
import { ReactComponent as AmexIcon } from 'payment-icons/min/flat/amex.svg';
import { ReactComponent as DefaultIcon } from 'payment-icons/min/flat/default.svg';
import { ReactComponent as DinersIcon } from 'payment-icons/min/flat/diners.svg';
import { ReactComponent as DiscoverIcon } from 'payment-icons/min/flat/discover.svg';
import { ReactComponent as EloIcon } from 'payment-icons/min/flat/elo.svg';
import { ReactComponent as HiperCardIcon } from 'payment-icons/min/flat/hipercard.svg';
import { ReactComponent as JcbIcon } from 'payment-icons/min/flat/jcb.svg';
import { ReactComponent as MaestroIcon } from 'payment-icons/min/flat/maestro.svg';
import { ReactComponent as MastercardIcon } from 'payment-icons/min/flat/mastercard.svg';
import { ReactComponent as PaypalIcon } from 'payment-icons/min/flat/paypal.svg';
import { ReactComponent as SecurityCodeIcon } from 'payment-icons/min/flat/security-code.svg';
import { ReactComponent as UnionPayIcon } from 'payment-icons/min/flat/unionpay.svg';
import { ReactComponent as VerveIcon } from 'payment-icons/min/flat/verve.svg';
import { ReactComponent as VisaIcon } from 'payment-icons/min/flat/visa.svg';

const defaultProps = {
  width: 40,
  height: '100%',
};

export const getCcIcon = (type?: string, size = 40): ReactElement => {
  const props = {
    ...defaultProps,
    width: size,
  };
  switch (true) {
    case type === 'alipay':
      return <AlipayIcon {...props} />;
    case type === 'american-express':
      return <AmexIcon {...props} />;
    case type === 'diners-club':
      return <DinersIcon {...props} />;
    case type === 'discover':
      return <DiscoverIcon {...props} />;
    case type === 'elo':
      return <EloIcon {...props} />;
    case type === 'hipercard':
      return <HiperCardIcon {...props} />;
    case type === 'hiper':
      return <HiperCardIcon {...props} />;
    case type === 'jcb':
      return <JcbIcon {...props} />;
    case type === 'maestro':
      return <MaestroIcon {...props} />;
    case type === 'mastercard':
      return <MastercardIcon {...props} />;
    case type === 'unionpay':
      return <UnionPayIcon {...props} />;
    case type === 'verve':
      return <VerveIcon {...props} />;
    case type === 'visa':
      return <VisaIcon {...props} />;
    case type === 'paypal':
      return <PaypalIcon {...props} />;
    case type === 'security-code':
      return <SecurityCodeIcon {...props} />;
    default:
      return <DefaultIcon {...props} />;
  }
};
